import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function ProprietarStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Persoana juridica"
          description="Proprietarul este o firma / societate comerciala"
          checked={!!data.proprietarPJ}
          onChange={() => update("proprietarPJ")(!data.proprietarPJ)}
        />
      </div>

      {data.proprietarPJ ? (
        <>
          <InputField label="Denumire societate" value={data.proprietarFirma} onChange={update("proprietarFirma")} placeholder="ex: SC Exemplu SRL" required error={errors.proprietarFirma} />
          <InputField label="CUI" value={data.proprietarCUI} onChange={update("proprietarCUI")} placeholder="ex: RO12345678" required half error={errors.proprietarCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.proprietarRegCom} onChange={update("proprietarRegCom")} placeholder="ex: J40/1234/2020" half error={errors.proprietarRegCom} />
          <InputField label="Sediu social" value={data.proprietarSediu} onChange={update("proprietarSediu")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.proprietarSediu} />
          <InputField label="Reprezentant legal" value={data.proprietarReprezentant} onChange={update("proprietarReprezentant")} placeholder="ex: Popescu Ion" required error={errors.proprietarReprezentant} />
        </>
      ) : (
        <>
          <InputField label="Nume complet" value={data.proprietarNume} onChange={update("proprietarNume")} placeholder="ex: Popescu Ion" required error={errors.proprietarNume} />
          <InputField label="Adresa de domiciliu" value={data.proprietarAdresa} onChange={update("proprietarAdresa")} placeholder="ex: Str. Exemplu nr. 1, Bucuresti" required error={errors.proprietarAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.proprietarCNP} onChange={update("proprietarCNP")} placeholder="ex: 1234567890123" half error={errors.proprietarCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.proprietarCI} onChange={update("proprietarCI")} placeholder="ex: RD 123456" half error={errors.proprietarCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}
    </div>
  );
}
